/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelChangeStatusRequest,
  ModelCommonResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ChangeProjectStatus<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description change project status
   *
   * @tags project
   * @name ChangeProjectStatusCreate
   * @summary change project status
   * @request POST:/changeProjectStatus
   */
  changeProjectStatusCreate = (
    request: ModelChangeStatusRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/changeProjectStatus`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
